module.exports = __webpack_public_path__ + "static/media/eminence-asakusa-5.8f9b28b0.jpg";